import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button, Table, PageHeader, Card, Badge, Tooltip }  from 'antd';
import { fetchAllClusterConfig, deleteClusterConfig } from '../actions';
import { breadCrumbItemRender } from '../../../utils/helpers'
import Content from '../../../component/Content';
import enablementGroups from '../../../constants/defaultSettingVariationConstants';

const breadcrumbConf = { 
  routes: [
    {
      path: '/clusters',
      breadcrumbName: 'Clusters',
    },
    {
      path: '/clusters/configs',
      breadcrumbName: 'Cluster Configs',
    },
  ],
  itemRender: breadCrumbItemRender
};

const renderLaunchgroup = launchgroup => {
  const group = enablementGroups.filter(grp => grp.key === launchgroup);
  if (!group.length) return 'null';
  return group[0].name || 'Classic | Client';
};

class ClusterConfigs extends PureComponent {

  componentDidMount() {
    this.props.fetchAllClusterConfig()
  }

  renderDate = date => new Date(date).toLocaleString();
  renderStatus = (status, row) => {
    switch(status) {
      case 'pending':
        return <Badge status="processing" text="in Queue"/>
      case 'processing':
        return <Badge status="processing" text="Processing"/>
      case 'error':
        return <Badge status="error" text="Error"/>
      case 'done':
        return <Badge status="success" text="Exported"/>
      default: //unreachable
    }
  } 

  renderActions = hubConfigId => {
    return (
      <Button
        type="link"
        onClick={() => this.props.deleteClusterConfig(hubConfigId) }>
        Delete
      </Button>
    );
  };

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'CLuster Id',
      dataIndex: 'cluster',
      key: 'cluster',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: this.renderStatus,
    },
    {
      title: 'Launch Group',
      dataIndex: 'data.srcCluster.defaultSetting',
      key: 'launchgroup',
      render: renderLaunchgroup,
    },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: this.renderDate,
    },
    {
      title: 'Created By User',
      dataIndex: 'createdBy',
      key: 'createdBy',
    },
    {
      title: 'Delete Config',
      dataIndex: 'id',
      key: 'deleteConfig',
      render: this.renderActions,
    }
  ];

  render() {
    const { loading, clusterConfigs } = this.props;
    return (
      <div>
        <PageHeader title="Cluster Configs" breadcrumb={breadcrumbConf}/>
        <Content>
          <Card bordered={false}>
            <Table 
              loading={loading} 
              columns={this.columns} 
              dataSource={clusterConfigs} 
            />
          </Card>
        </Content>
      </div>
    )
  }
}

const mapStateToProps = ({
  cluster: {
    clusterConfigs,
    clusterConfigsLoading: loading,
  }
}) => ({
  clusterConfigs,
  loading
});

const mapDispatchToProps = {
  fetchAllClusterConfig,
  deleteClusterConfig
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(ClusterConfigs));
